export const currency = '$'
export const currentYear = new Date().getFullYear()
export const developedByLink = 'https://stackbros.com/'
export const developedBy = 'Stackbros'
export const contactUs = 'mailto:stackbros07@gmail.com'
export const buyLink = ''
export const basePath = ''
export const DEFAULT_PAGE_TITLE = 'Edunav Next | LMS,Education and Course Theme'
export const colorVariants = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light']
